import { HttpParams } from '@angular/common/http';
import { BcmCostCenter } from '@shared/models/bcm-cost-center';
import { Product } from '@shared/models/product';

export function buildProductSelectHttpParams(
    costCenter: BcmCostCenter | null | undefined,
    costCenterFilterType: string | null | undefined,
): HttpParams | undefined {
    if (!costCenter?.id) {
        return undefined;
    }

    return new HttpParams()
        .set('costCenterId', String(costCenter.id))
        .set('costCenterFilterType', costCenterFilterType ?? '');
}

export function resolveDefaultCostCenterFilterType(
    costCenter: BcmCostCenter | null | undefined,
    isNewPosition: boolean,
): string | null {
    if (costCenter?.id && isNewPosition) {
        return 'all';
    }

    return null;
}

export function applyInvoicePositionProductsFilter(
    products: Product[],
    productsFilterFn?: (product: Product) => boolean,
): Product[] {
    if (typeof productsFilterFn === 'function') {
        return products.filter(productsFilterFn);
    }

    return products;
}
